function isValidDate(day, month, year) {
  var date = new Date(year, month - 1, day);
  return date && (date.getMonth() + 1) == month && date.getDate() == Number(day);
}

var dayField = document.getElementById('AgeGate-Day');
var monthField = document.getElementById('AgeGate-Month');
var yearField = document.getElementById('AgeGate-Year');
var submitButton = document.querySelector('.js-submit');
var errorMessage = document.querySelector('.js-error');

[dayField, monthField, yearField].forEach(function(field) {
  field.addEventListener('change', function() {
    var day = dayField.value;
    var month = monthField.value;
    var year = yearField.value;

    if (!isValidDate(day, month, year)) {
      submitButton.disabled = true;
      errorMessage.classList.remove('age-gate__error--hidden');
      errorMessage.textContent = `${window.ageGateErrorMessages.ageGateError}`;
    } else {
      submitButton.disabled = false;
      errorMessage.classList.add('age-gate__error--hidden');
    }
  });
});